<h2 mat-dialog-title>
  {{ data.id ? 'Edit Schedule' : 'Add Schedule' }}
</h2>
<form (ngSubmit)="onSubmit()" #scheduleForm="ngForm" autocomplete="off">
  <mat-dialog-content>
    <div class="form-fields-vertical">
      <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 1.5rem;">
        <mat-label>Name</mat-label>
        <input matInput name="name" [(ngModel)]="data.name" required />
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 1.5rem;">
        <mat-label>Resource Types</mat-label>
        <mat-select [(ngModel)]="selectedResourceTypes" name="resourceTypes" multiple (selectionChange)="onResourceTypesChange()">
          <mat-option *ngFor="let type of resourceTypes" [value]="type.id.toString()">
            {{ type.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 2rem;" *ngIf="selectedResourceTypes.length > 0">
        <mat-label>Required Resource Types</mat-label>
        <mat-select [(ngModel)]="requiredResourceTypes" name="requiredResourceTypes" multiple>
          <mat-option *ngFor="let rtId of selectedResourceTypes" [value]="rtId">
            {{ getResourceTypeName(rtId) }}
          </mat-option>
        </mat-select>
        <mat-hint>Select which resource types MUST be scheduled in every session. Unselected types are optional.</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%; margin-bottom: 1.5rem;">
        <mat-label>Primary Resource Type</mat-label>
        <mat-select [(ngModel)]="primaryResourceTypeId" name="primaryResourceTypeId" required>
          <mat-option [value]="null">None</mat-option>
          <mat-option
            *ngFor="let type of resourceTypes"
            [value]="type.id.toString()"
            [disabled]="selectedResourceTypes.indexOf(type.id.toString()) === -1"
          >
            {{ type.name }}
          </mat-option>
        </mat-select>

      </mat-form-field>

      <div *ngIf="loading" style="text-align: center; margin-top: 10px;">
        Loading resource types...
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="!data.name"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
